import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumn, FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXMobileHealthExLogoFullWidth } from "./HXMobileLogos.styles";
export const AvatarLaunchWrap = styled.div `
    display: inline-flex;
    transition: transform 140ms cubic-bezier(0.4, 0, 0.2, 1);
    transform: ${(p) => (p.$pulse ? "scale(1.05)" : "scale(1)")};
`;
export const NavRoot = styled(FlexColumnDiv) `
    align-self: stretch;
    background-color: ${colors.white_main};
`;
export const TopRow = styled(FlexRowDiv) `
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px 12px 16px;
    box-sizing: border-box;

    ${(props) => props.showBottomBorder &&
    css `
            border-bottom: 1px solid ${colors.black_12};
        `}
`;
export const LogoButtonContainer = styled(FlexColumn) `
    min-height: 32px;
    align-items: center;
    justify-content: center;
`;
export const LogoButton = styled.button `
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
`;
export const NavLogo = styled(HXMobileHealthExLogoFullWidth) `
    height: ${(props) => (props.height !== undefined ? `${props.height}px` : "20px")};
    display: block;
`;
export const AvatarSpacer = styled.div `
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;
export const TabsBar = styled.div `
    align-self: stretch;
    border-bottom: 1px solid ${colors.black_12};
`;
export const NavTabs = styled(Tabs) `
    min-height: 0;
    padding: 0 8px;

    & .MuiTabs-flexContainer {
        gap: 0;
    }

    & .MuiTabs-indicator {
        height: 2px;
        background-color: ${colors.black_main};
        transition: left 200ms cubic-bezier(0.4, 0, 0.2, 1), width 200ms cubic-bezier(0.4, 0, 0.2, 1);
    }
`;
export const NavTab = styled(Tab) `
    && {
        flex: 1 1 0;
        min-width: 0;
        min-height: 0;
        padding: 16px;
        text-transform: none;
        font-size: ${fontSizes.SMALL};
        font-weight: ${fontWeights.NORMAL};
        color: ${colors.black_lighter};
        letter-spacing: 0.17px;
        opacity: 1;

        &.Mui-selected {
            font-weight: ${fontWeights.BOLD};
            color: ${colors.black_main};
            letter-spacing: 0;
        }
    }
`;
